import React from 'react';
import Icon from './icon-map';

interface CaregiverFeatureProps {
  icon: string;
  title: string;
  description: string;
}

/**
 * CaregiverFeature Component
 * 
 * Displays a single caregiver feature with icon, title and description
 * Used within the Caregivers page to highlight caregiver-focused features
 * Follows mobile-first responsive design principles
 * 
 * @param {string} icon - Icon name from the Lucide icon set
 * @param {string} title - Feature title
 * @param {string} description - Feature description
 * @returns {JSX.Element} A feature card component
 */
const CaregiverFeature: React.FC<CaregiverFeatureProps> = ({
  icon,
  title,
  description
}) => {
  return (
    <div className="flex items-start space-x-4 bg-white rounded-lg p-4 shadow-sm border border-purple-100 transition-all hover:shadow-md">
      <div className="mt-1 flex-shrink-0">
        <Icon name={icon} className="h-6 w-6 text-purple-600" />
      </div>
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-1">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default CaregiverFeature;
